export const settings = {
  setShareTitle: 'App teilen',
  setNotifiationsTitle: 'Benachrichtigungen',
  setContactAppOwnerTitle: 'App-Besitzer kontaktieren',
  setContactDevelopersTitle: 'Entwickler kontaktieren',
  setReportAppTitle: 'App melden',
  setDeleteAccountTitle: 'Konto löschen',
  setLogOutTitle: 'Abmelden',
  setShareAppCurtainTitle: 'App teilen',
  setShareAppCurtainButtonTitle: 'Link kopieren',
  setShareAppAlertWhenAppLinkWasCopied: 'Link kopiert!',
  setNotificationsInAppTitle: 'In der App',
  setNotificationsPushContent: 'Push-Benachrichtigungen',
  setNotificationsChatsTitle: 'Chats',
  setNotificationsDiscussionsTitle: 'Diskussionen',
  setNotificationsNewsTitle: 'Neuigkeiten',
  setNotificationsEventsTitle: 'Veranstaltungen',
  setNotificationsAdminTitle: 'Admin-Nachrichten',
  setNotificationsBlogTitle: 'Blog',
  setNotificationsPushOffContent: 'Push-Benachrichtigungen sind deaktiviert',
  setNotificationsPushOffText:
    'Um sie zu aktivieren, gehen Sie bitte zu den Einstellungen Ihres Geräts und erlauben Sie Benachrichtigungen',
  setReportAppFlagCurtainTitle: 'Melden',
  setAppReportedCurtainContent: 'Inhalt gemeldet',
  setDeleteCurtainTitle: 'Konto löschen',
  setDeleteCurtainInputContent: 'Passwort',
  setDeleteCurtainCancelButtonTitle: 'Abbrechen',
  setDeleteCurtainConfirmButtonTitle: 'Bestätigen',
  setDeleteCurtainIncorrectPasswordAlertText: 'Falsches Passwort',
  setTurnNotificationsOnText:
    'Um sie zu aktivieren, klicken Sie bitte auf die Schaltfläche unten und erlauben Sie den Empfang von Benachrichtigungen.',
  setTurnNotificationsOnButton: 'Push-Benachrichtigungen aktivieren',
  changeLanguage: 'App-Sprache ändern',
  changeLanguageAlertSuccess: 'App-Sprache wurde erfolgreich geändert'
}
